import {getLookupHostname, normalizeDomain, isLightlyPlatformHost, getOrgSlugFromPath} from "../utils/routing/hostUtils";
import {readPublicOrganizationRoute} from "./publicOrganizationReader";

export async function getDomainMapping(domain) {
  const host = getLookupHostname(domain);
  if (!host) return null;
  const mapping = await readPublicOrganizationRoute(`domain:${host}`);
  if (!mapping) return null;
  return {orgSlug: mapping.organizationId, orgId: mapping.organizationId, domain: host, canonicalHost: host, status: "active", verified: true};
}

export async function resolveOrgContextFromLocation({ hostname, pathname } = {}) {
  const normalizedHostname = normalizeDomain(hostname);
  const lookupHostname = getLookupHostname(normalizedHostname);

  if (isLightlyPlatformHost(lookupHostname)) {
    return {
      orgSlug: getOrgSlugFromPath(pathname, lookupHostname),
      hostname: normalizedHostname,
      canonicalHost: lookupHostname,
      mode: "slug",
      customDomain: "",
      isCustomDomain: false,
      domainMapping: null,
    };
  }

  const mapping = await getDomainMapping(lookupHostname);
  if (!mapping?.orgSlug) {
    return {
      orgSlug: "",
      hostname: normalizedHostname,
      canonicalHost: lookupHostname,
      mode: "customDomain",
      customDomain: lookupHostname,
      isCustomDomain: true,
      domainMapping: null,
    };
  }

  return {
    orgSlug: mapping.orgSlug,
    orgId: mapping.orgId || "",
    hostname: normalizedHostname,
    canonicalHost: mapping.canonicalHost || lookupHostname,
    mode: "customDomain",
    customDomain: mapping.domain || lookupHostname,
    isCustomDomain: true,
    domainMapping: mapping,
  };
}
